import type { JobRunStatus } from '../types/source-system';

const LABELS: Record<JobRunStatus, string> = {
  pending: 'Pending',
  running: 'Running',
  completed: 'Completed',
  partial: 'Partial',
  failed: 'Failed',
  cancelled: 'Cancelled',
  skipped: 'Skipped',
};

interface SyncStatusBadgeProps {
  status: JobRunStatus | null;
}

/**
 * Small status pill used inside sync and data sections.
 */
export function SyncStatusBadge({ status }: SyncStatusBadgeProps) {
  if (!status) {
    return <span className="sync-status sync-status--none">No runs yet</span>;
  }
  return (
    <span className={`sync-status sync-status--${status}`} aria-label={`Status: ${LABELS[status]}`}>
      {LABELS[status]}
    </span>
  );
}
